import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import aqtLogo from "../../assets/images/aqtlogo.png";

const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "Businesses", to: "/businesses" },
  { label: "Onboard AFO", to: "/afo" },
  { label: "Investors", to: "/investors" },
  { label: "Partners", to: "/partners" },
  { label: "Roadmap", to: "/roadmap" },
  { label: "Masterclass", to: "/masterclass" },
  { label: "Insights", to: "/insights" },
];

const MOBILE_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Businesses", to: "/businesses" },
  { label: "AFO", to: "/afo" },
  { label: "Investors", to: "/investors" },
  { label: "Sectors", to: "/sectors" },
  { label: "Partners", to: "/partners" },
  { label: "Masterclass", to: "/masterclass" },
  { label: "Insights", to: "/insights" },
  { label: "Blogs", to: "/blogs" },
  { label: "Legal & Policies", to: "/legal" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <>
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 200,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 6%", height: "72px",
        background: "rgba(255,255,255,0.96)", backdropFilter: "blur(16px)",
        borderBottom: "1px solid rgba(26,79,160,0.12)",
        boxShadow: scrolled ? "0 2px 32px rgba(26,79,160,0.09)" : "none",
        transition: "box-shadow 0.3s",
        fontFamily: "'DM Sans', sans-serif",
      }}>
        {/* Logo */}
        <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
          <img src={aqtLogo} alt="AQT Direct Limited" style={{ height: 48, width: "auto", display: "block" }} />
        </Link>

        {/* Desktop Links */}
        <ul className="aqt-nav-desktop" style={{ display: "flex", gap: 0, listStyle: "none", margin: 0, padding: 0, alignItems: "center" }}>
          {NAV_LINKS.map(({ label, to, dropdown }) => (
            <li key={label} className={dropdown ? "aqt-nav-dropdown" : ""}>
              <Link
                to={to}
                className={`aqt-nav-link${location.pathname === to ? " active" : ""}`}
              >
                {label}
              </Link>
              {dropdown && (
                <div className="aqt-nav-drop">
                  {dropdown.map(d => (
                    <Link key={d.label} to={d.to} className="aqt-drop-link">{d.label}</Link>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>

        {/* CTA */}
        <Link
          to="/contactus"
          className="aqt-nav-cta"
          style={{
            background: "linear-gradient(135deg,#1DB88A 0%,#1A6BC4 60%,#1A4FA0 100%)",
            color: "white", padding: "9px 20px", borderRadius: 6,
            fontSize: 13, fontWeight: 500, textDecoration: "none",
            letterSpacing: "0.02em", whiteSpace: "nowrap",
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Register Interest
        </Link>

        {/* Hamburger */}
        <button
          className="aqt-hamburger"
          onClick={() => setMobileOpen(o => !o)}
          style={{ flexDirection: "column", gap: 5, background: "none", border: "none", cursor: "pointer", padding: 6 }}
          aria-label="Menu"
        >
          <span style={{ display: "block", width: 22, height: 2, background: "#0F2D6B", borderRadius: 2 }} />
          <span style={{ display: "block", width: 22, height: 2, background: "#0F2D6B", borderRadius: 2 }} />
          <span style={{ display: "block", width: 22, height: 2, background: "#0F2D6B", borderRadius: 2 }} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div style={{
          position: "fixed", top: 72, left: 0, right: 0, bottom: 0, zIndex: 190,
          background: "rgba(255,255,255,0.98)", backdropFilter: "blur(16px)",
          borderTop: "1px solid rgba(26,79,160,0.12)",
          overflowY: "auto", fontFamily: "'DM Sans', sans-serif",
        }}>
          {/* Logo row */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "16px 6%", borderBottom: "1px solid rgba(26,79,160,0.08)",
          }}>
            <Link to="/" onClick={() => setMobileOpen(false)}>
              <img src={aqtLogo} alt="AQT Direct Limited" style={{ height: 44, width: "auto", display: "block" }} />
            </Link>
          </div>

          {/* Nav links */}
          <div style={{ padding: "8px 6% 0" }}>
            {NAV_LINKS.map(({ label, to }) => (
              <Link key={label} to={to}
                onClick={() => setMobileOpen(false)}
                style={{
                  display: "flex", alignItems: "center", padding: "13px 16px",
                  fontSize: 14, fontWeight: 400, color: location.pathname === to ? "#1A4FA0" : "#5A6A7E",
                  textDecoration: "none", borderRadius: 8,
                  background: location.pathname === to ? "rgba(26,79,160,0.06)" : "transparent",
                  borderBottom: "1px solid rgba(26,79,160,0.06)",
                  letterSpacing: "0.02em",
                }}
              >
                {label}
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div style={{ padding: "16px 6% 32px" }}>
            <Link to="/contactus"
              onClick={() => setMobileOpen(false)}
              style={{
                display: "block", textAlign: "center", padding: "13px 20px", borderRadius: 6,
                background: "linear-gradient(135deg,#1DB88A 0%,#1A6BC4 60%,#1A4FA0 100%)",
                color: "white", fontSize: 14, fontWeight: 500, textDecoration: "none",
                letterSpacing: "0.02em",
              }}>
              Register Interest
            </Link>
          </div>
        </div>
      )}

      <style>{`
        .aqt-nav-link {
          display: block; font-size: 13px; font-weight: 400; color: #5A6A7E;
          text-decoration: none; letter-spacing: .02em; padding: 8px 13px;
          border-radius: 6px; transition: color 0.2s, background 0.2s;
        }
        .aqt-nav-link:hover, .aqt-nav-link.active { color: #1A4FA0; background: rgba(26,79,160,0.06); }
        .aqt-nav-dropdown { position: relative; }
        .aqt-nav-drop {
          position: absolute; top: 100%; left: 0; background: white;
          border: 1px solid rgba(26,79,160,0.12); border-radius: 8px; min-width: 160px;
          box-shadow: 0 8px 32px rgba(26,79,160,0.12); padding: 6px 0;
          opacity: 0; pointer-events: none; transform: translateY(4px);
          transition: opacity .2s, transform .2s; z-index: 300;
        }
        .aqt-nav-drop::before { content: ''; position: absolute; top: -10px; left: 0; right: 0; height: 10px; }
        .aqt-nav-dropdown:hover .aqt-nav-drop { opacity: 1; pointer-events: all; transform: translateY(0); }
        .aqt-drop-link {
          display: block; padding: 10px 16px; font-size: 13px; color: #5A6A7E;
          text-decoration: none; transition: color .2s, background .2s;
        }
        .aqt-drop-link:hover { color: #1A4FA0; background: #F7F9FC; }
        .aqt-nav-cta:hover { opacity: 0.88; }
        .aqt-nav-desktop { display: flex !important; }
        .aqt-hamburger { display: none !important; }
        @media (max-width: 960px) {
          .aqt-nav-desktop { display: none !important; }
          .aqt-nav-cta { display: none !important; }
          .aqt-hamburger { display: flex !important; }
        }
      `}</style>

      {/* Spacer for fixed nav */}
      <div style={{ height: 72 }} />
    </>
  );
}
